/**
 * MarketplaceDialog
 *
 * Thin dialog wrapper around the canonical marketplace browse surface.
 * The full page and dialog must share one implementation so marketplace
 * install/detail behavior cannot drift.
 */
import { Modal } from '@affine/component/ui/modal';
import type { DialogComponentProps } from '@affine/core/modules/dialogs';
import type { WORKSPACE_DIALOG_SCHEMA } from '@affine/core/modules/dialogs/constant';

import { MarketplaceBrowseContent } from './marketplace-browse-content';

export const MarketplaceDialog = ({
  close,
  initialCategory,
}: DialogComponentProps<WORKSPACE_DIALOG_SCHEMA['marketplace']>) => {
  return (
    <Modal
      width={1200}
      height={800}
      contentOptions={{
        style: {
          display: 'flex',
          maxHeight: '90vh',
          overflow: 'hidden',
          padding: 0,
          position: 'relative',
        },
      }}
      open
      onOpenChange={() => close()}
    >
      <MarketplaceBrowseContent
        initialCategory={initialCategory}
        onClose={() => close()}
      />
    </Modal>
  );
};
